module.exports = __webpack_public_path__ + "static/media/saga.7a4c2b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/saga.png
// module id = 28
// module chunks = 0